import { IPricingRuleStoreSegment } from './pricingRule.interface';

export const pricingRuleStoreSelector = (state: IPricingRuleStoreSegment) => state.pricingRule;
